import {
  createRoute,
  lazyRouteComponent,
  redirect,
} from "@tanstack/react-router";

import {
  trackAlertsEmailClicked,
  trackAlertsPageViewed,
} from "@/config/mixpanel";
import { validateEmailLinkSearch } from "@/routes/emailLinkSearch";
import { rootRoute } from "@/routes/rootRoute";

/* eslint-disable @typescript-eslint/only-throw-error */

export const alertsRoute = createRoute({
  path: "/alerts",
  getParentRoute: () => rootRoute,
  validateSearch: validateEmailLinkSearch,
  beforeLoad: ({ search, location }) => {
    if (search.source === "email" && search.cta === "configure") {
      trackAlertsEmailClicked("configure");
      trackAlertsPageViewed("email");
      throw redirect({ href: location.pathname, replace: true });
    }
    if (search.source === "popup") {
      trackAlertsPageViewed("popup");
      throw redirect({
        to: "/alerts",
        replace: true,
        state: { openActivationForm: true },
      });
    }
  },
  component: lazyRouteComponent(async () => {
    const m = await import("./Alerts");
    return { default: m.Alerts };
  }),
});
